import { Injectable } from '@angular/core';
import { distinctUntilChanged } from 'rxjs/operators';
import { Subject } from 'rxjs/Subject';

@Injectable()
export class CallService {

  // Observable string sources
  private patcomponentMethodCallSource = new Subject<any>();
  private pqtcomponentMethodCallSource = new Subject<any>();
  mytodocomponentMethodCallSource = new Subject<any>();
  private messagescallComponentMethodCallSource = new Subject<any>();

  // Observable string streams
  patcomponentMethodCalled$ = this.patcomponentMethodCallSource.asObservable().pipe(distinctUntilChanged());
  pqtcomponentMethodCalled$ = this.pqtcomponentMethodCallSource.asObservable().pipe(distinctUntilChanged());
  mytodocomponentMethodCalled$ = this.mytodocomponentMethodCallSource.asObservable().pipe(distinctUntilChanged());
  messagescomponentMethodCalled$ = this.messagescallComponentMethodCallSource.asObservable().pipe(distinctUntilChanged());

  // Service message commands
  patcallComponentMethod() {
    this.patcomponentMethodCallSource.next(new Subject<any>());

  }
  pqtcallComponentMethod() {
    this.pqtcomponentMethodCallSource.next(new Subject<any>());

  }
  mytodocallComponentMethod() {
    this.mytodocomponentMethodCallSource.next(new Subject<any>());

  }
  messagescallComponentMethod() {
    this.messagescallComponentMethodCallSource.next(new Subject<any>());
  }

}
